export default {
    show: false,
    message: [],
    type: 1,
    fnCallback: () => { },
    fnCallbackNo: () => {},
    isConfirmDialog: false
}